import * as d3 from 'd3';

const graphics = {
    svg : null,
    mainLayer : null,
    toggleLayer : null,
    healthLayer : null,
    expectancyLayer : null,
    expectancyScore : null,
    economicLayer : null,
    economicLabels:[],
    environmentLayer : null,
    environmentPath : null,
    environmentSquare : null,
    environmentLabel: null,
    button: null,
    monthTime : 300,
    healthCounter : null,
    expectancyLabel : null
};
// const drag = d3.behavior.drag().on('dragstart', function() {
// }).on('drag', function() {
//     const x = d3.event.x;
//     d3.select(this).attr('cx', limitX(x));
// }).on('dragend', function() {
//     //const x = d3.event.x;
//     // todo
//     const x = 10;
//     d3.select(this).attr('cx', positionX(x, this));
// });


const benefits = {
    health : {
        people : 430,
        survived : 224,
        current : 430,
        running : null,
    },
    expectancy : [7.4, 4.1],
    economic : [
        [1.7, 3],
        [8, 15.8],
        [2.4, 4],
        [0.3, 1]
    ],
    environment : {
        data : {
            start: calcPercent(0),
            lower: calcPercent(62),
            upper: calcPercent(44),
            current : 0
        },
        pie : d3.layout.pie().sort(null),
        format : d3.format('.0%'),
        arc : d3.svg.arc().innerRadius(30).outerRadius(70),
        path : null,
        text : null,
        color : ['#31B5AD', '#fff'],
        squareValues : [22.7, 110.0, 0.0]
    }
};

let toggleStatus = false;

function buildCanvas(element) {
    graphics.svg = d3.select(element).append('svg').attr('width', '100%').attr('height', '100%');
    graphics.mainLayer = graphics.svg.append('g');
    graphics.toggleLayer = graphics.mainLayer.append('g').attr('class', 'benefits-layer-toggle');
    graphics.healthLayer = graphics.mainLayer.append('g').attr('class', 'benefits-layer-health').attr('transform', function() {
        return 'translate(0, 80)';
    });
    graphics.expectancyLayer = graphics.mainLayer.append('g').attr('class', 'benefits-layer-expectancy').attr('transform', function() {
        return 'translate(600, 80)';
    });
    graphics.economicLayer = graphics.mainLayer.append('g').attr('class', 'benefits-layer-economic').attr('transform', function() {
        return 'translate(0, 440)';
    });
    graphics.environmentLayer = graphics.mainLayer.append('g').attr('class', 'benefits-layer-environment').attr('transform', function() {
        return 'translate(500, 440)';
    });
}

function buildToggle() {
    var g = graphics.toggleLayer.append('g').attr('class', 'action-toggle');
    g.append('text').attr('x', 0).attr('y', 20).text('Now').attr('class', 'action-toggle-label');
    g.append('text').attr('x', 100).attr('y', 20).text('2030').attr('class', 'action-toggle-label');
    g.append('path').attr('d', 'M91.428,14c0,7.701-6.356,14-14.124,14H51.124C43.355,28,37,21.7,37,14c0-7.7,6.355-14,14.124-14h26.181C85.072,0,91.428,6.3,91.428,14').attr('class', 'action-toggle-container');
    g.append('circle').attr('r', 11).attr('cx', 52).attr('cy', 14).attr('class', 'action-toggle-button-hidden').on('click', function () {
        setToggle(false);
    });
    g.append('circle').attr('r', 11).attr('cx', 76).attr('cy', 14).attr('class', 'action-toggle-button-hidden').on('click', function () {
        setToggle(true);
    });
    graphics.button = g.append('circle').attr('r', 11).attr('cx', 52).attr('cy', 14).attr('class', 'action-toggle-button').on('click', function () {
        toggleToggle();
    });
}

function setToggle(status) {
    toggleStatus = status;
    if (status) {
        graphics.button.attr('cx', 76);
        setTo2030();
        graphics.button.attr('class', 'action-toggle-button action-toggle-button-active');
    } else {
        graphics.button.attr('cx', 52);
        setToNow();
        graphics.button.attr('class', 'action-toggle-button');
    }
}

function toggleToggle() {
    toggleStatus = !toggleStatus;
    if (toggleStatus) {
        graphics.button.attr('cx', 76);
        setTo2030();
        graphics.button.attr('class', 'action-toggle-button action-toggle-button-active');
    } else {
        graphics.button.attr('cx', 52);
        setToNow();
        graphics.button.attr('class', 'action-toggle-button');
    }
}

function buildHealth() {
    var y = 30,
        x = 0,
        row = 70;
    graphics.healthLayer.append('text').attr('class', 'benefits-header').text('Health');
    graphics.healthCounter = graphics.healthLayer.append('text').attr('class', 'bold-12').text(benefits.health.people + ' 000 Premature deaths').attr('y', 260);
    graphics.healthLayer.append('text').attr('class', 'bold-12').text('= 1000 Lives').attr('x', 485).attr('y', 260);
    graphics.healthLayer.append('rect').attr({
        x: 475,
        y: 245,
        width: 5,
        height: 20,
        fill: '#31B5AD'
    });
    for (var i = 0; i < benefits.health.people; i++) {
        graphics.healthLayer.append('rect').attr('width', 5).attr('height', 20).attr('x', x).attr('y', y).attr('class', 'benefits-kills').attr('id', 'benefits-kills-' + i);
        x += 8;
        if (x >= row * 8) {
            y += 30;
            x = 0;
        }
    }
    graphics.healthLayer.append('text').attr('class', 'regular-12').attr('x', 180).attr('y', -60).text('2030: If the new Clean Air Policy');
    //graphics.healthLayer.append('text').attr('class', 'regular-12').attr('x', 170).attr('y', -54).text('Package becomes EU rules');
    graphics.healthLayer.append('text').attr('class', 'regular-12').attr('x', 180).attr('y', -40).text('Package becomes EU rules');
}

function launchHealth(i) {
    if (benefits.health.running === 'launch') {
        var counter = i;
        counter--;
        graphics.healthCounter.text(i + ' 000 Premature deaths');
        d3.select('#benefits-kills-' + i).attr('class', 'benefits-kills benefits-survived');
        if (counter >= benefits.health.survived) {
            setTimeout(function () {
                launchHealth(counter);
            }, 10);
        }
        benefits.health.current = i;
    }
}

function restoreHealth(i) {
    if (benefits.health.running === 'restore') {
        var counter = i;
        counter++;
        graphics.healthCounter.text(i + ' 000 Premature deaths');
        d3.select('#benefits-kills-' + i).attr('class', 'benefits-kills');
        if (counter <= benefits.health.people) {
            setTimeout(function () {
                restoreHealth(counter);
            }, 10);
        }
        benefits.health.current = i;
    }
}

function buildExpectancy() {
    graphics.expectancyLayer.append('text').attr('class', 'benefits-header').attr('y', -22).text('Life expectancy');
    graphics.expectancyLayer.append('text').attr('class', 'benefits-header').text('shortened by:');
    graphics.expectancyLayer.append('text').attr('class', 'bold-12').text('months').attr('x', 40).attr('y', 107).attr('text-anchor', 'middle');
    graphics.expectancyScore = graphics.expectancyLayer.append('text').attr('class', 'regular-36').text(benefits.expectancy[0]).attr('x', 10).attr('y', 70);
    graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect').attr('width', 80).attr('height', 55).attr('y', 30);
    graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect').attr('width', 80).attr('height', 35).attr('y', 85);
    graphics.expectancyLabel = graphics.expectancyLayer.append('g').attr('class', 'hidable-element hidden').attr('transform', function() {
        return 'translate(0, 150)';
    });
    graphics.expectancyLabel.append('text').attr('class', 'regular-12').text('Life expectancy extended');
    graphics.expectancyLabel.append('text').attr('class', 'regular-12').attr('y', 16).text('by 3.3 months');
    for (var i = 0, l = 12; i < l; i++){
        if (i < 7) {
            graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect-filled-white').attr('width', 30).attr('height', 30).attr('x', (i % 4) * 30 + 80).attr('y', (Math.floor(i / 4)) * 30 + 30);
            graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect-filled benefits-month-' + i).attr('width', 30).attr('height', 30).attr('x', (i % 4) * 30 + 80).attr('y', (Math.floor(i / 4)) * 30 + 30);
        } else if (i === 7) {
            graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect-filled-white').attr('width', 30).attr('height', 12).attr('x', (i % 4) * 30 + 80).attr('y', (Math.floor(i / 4)) * 30 + 30);
            graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect-filled benefits-month-' + i).attr('width', 30).attr('height', 12).attr('x', (i % 4) * 30 + 80).attr('y', (Math.floor(i / 4)) * 30 + 30);
        }
        graphics.expectancyLayer.append('rect').attr('class', 'benefits-expectancy-rect').attr('width', 30).attr('height', 30).attr('x', (i % 4) * 30 + 80).attr('y', (Math.floor(i / 4)) * 30 + 30);
    }
}

function restoreExpectancy() {
    var start = Math.floor(benefits.expectancy[1]),
        duration = (Math.floor(benefits.expectancy[0] - benefits.expectancy[1]) + 1) * graphics.monthTime;
    restoreMonth(start);
    graphics.expectancyScore.transition().duration(duration).tween('text', function() {
        var i = d3.interpolate(benefits.expectancy[1], benefits.expectancy[0]);
        return function(t) {
            graphics.expectancyScore.text(i(t).toFixed(1));
        };
    });
    graphics.expectancyLabel.attr('class', 'hidable-element hidden');
}

function launchExpectancy() {
    var start = Math.floor(benefits.expectancy[0]),
        time = 500,
        duration = (Math.floor(benefits.expectancy[0] - benefits.expectancy[1]) + 1) * graphics.monthTime;
    killMonth(start, time);
    graphics.expectancyScore.transition().duration(duration).tween('text', function() {
        var i = d3.interpolate(benefits.expectancy[0], benefits.expectancy[1]);
        return function(t) {
            this.textContent = i(t).toFixed(1);
        };
    });
    graphics.expectancyLabel.attr('class', 'hidable-element');
}

function killMonth(month) {
    var rect = d3.select('.benefits-month-' + month),
        height,
        thisMonth = month,
        end = Math.floor(benefits.expectancy[1]);
    if (thisMonth === end) {
        height = benefits.expectancy[1] % 1;
    } else {
        height = 0;
    }
    rect.transition().duration(500).attr('height', height * 30);
    thisMonth--;
    if (thisMonth > (end - 1)) {
        setTimeout(function(){
            killMonth(thisMonth);
        }, graphics.monthTime);
    }
}

function restoreMonth(month) {
    var rect = d3.select('.benefits-month-' + month),
        height,
        thisMonth = month,
        end = Math.floor(benefits.expectancy[0]);
    if (thisMonth === end) {
        height = benefits.expectancy[0] % 1;
    } else {
        height = 1;
    }
    rect.transition().duration(500).attr('height', height * 30);
    thisMonth++;
    if (thisMonth < (end + 1)) {
        setTimeout(function(){
            restoreMonth(thisMonth);
        }, graphics.monthTime);
    }
}

function buildEconomic() {
    var g = graphics.economicLayer.append('g').attr('transform','translate(0, 36)'),
        circles = graphics.economicLayer.append('g').attr('transform','translate(0, 150)');
    graphics.economicLayer.append('text').attr('class', 'benefits-header').text('Economic costs of air pollution');
    for (var i = 0; i < 4; i++) {
        circles.append('circle').attr('r', (Math.sqrt(benefits.economic[i][1]) * 18)).attr('cx', (115 * i + 50)).attr('cy', 0).attr('class', 'benefits-economy-circle-passive');
        circles.append('circle').attr('id', 'benefits-economic-circle-' + i).attr('r', (Math.sqrt(benefits.economic[i][1]) * 18)).attr('cx', (115 * i + 50)).attr('cy', 0).attr('class', 'benefits-economy-circle');
        graphics.economicLabels[i] = circles.append('text').attr('class', 'white-17').text('€'+ benefits.economic[i][1]).attr('x', 115 * (i+ 0.5) - 8).attr('y', 0).attr('text-anchor','middle');
        circles.append('text').attr('class', 'white-12').text('bn').attr('x', 115 * (i+ 0.5) - 8).attr('y', 15).attr('text-anchor','middle');
    }
    g.append('text').attr('class', 'bold-12').text('crop').attr('x', 0).attr('y', 16);
    g.append('text').attr('class', 'bold-12').text('yield loss').attr('x', 0).attr('y', 32);
    g.append('text').attr('class', 'bold-12').text('workdays lost').attr('x', 115).attr('y', 16);
    g.append('text').attr('class', 'bold-12').text('due to sickness').attr('x', 115).attr('y', 32);
    g.append('text').attr('class', 'bold-12').text('direct').attr('x', 230).attr('y', 16);
    g.append('text').attr('class', 'bold-12').text('healthcare').attr('x', 230).attr('y', 32);
    g.append('text').attr('class', 'bold-12').text('damage').attr('x', 345).attr('y', 16);
    g.append('text').attr('class', 'bold-12').text('to buildings').attr('x', 345).attr('y', 32);
}

function lauchEconomic() {
    for (var i = 0; i < 4; i++) {
        var thisEconomic = benefits.economic[i];
        subLaunchEconomic(thisEconomic, i);
    }
}

function subLaunchEconomic(thisEconomic, i) {
    graphics.economicLabels[i].transition().duration(500).tween('text', function() {
        var q = d3.interpolate( thisEconomic[1],  thisEconomic[0]);
        return function(t) {
            this.textContent = '€' + decimal(q(t));
        };
    });
    d3.select('#benefits-economic-circle-' + i).transition().duration(500).attr('r', (Math.sqrt(thisEconomic[0]) * 18));
}

function restoreEconomic() {
    for (var i = 0; i < 4; i++) {
        var thisEconomic = benefits.economic[i];
        subRestoreEconomic(thisEconomic, i);
    }
}

function subRestoreEconomic(thisEconomic, i) {
    graphics.economicLabels[i].transition().duration(500).tween('text', function() {
        var q = d3.interpolate( thisEconomic[0],  thisEconomic[1]);
        return function(t) {
            this.textContent = '€' + decimal(q(t));
        };
    });
    d3.select('#benefits-economic-circle-' + i).transition().duration(500).attr('r', (Math.sqrt(thisEconomic[1]) * 18));
}

function decimal(a) {
    if (a % 1 === 0) {
        return a;
    } else {
        return a.toFixed(1);
    }
}

function buildEnvironment() {
    var g1 = graphics.environmentLayer.append('g').attr('transform', 'translate(70, 100)'),
        g2 = graphics.environmentLayer.append('g').attr('transform', 'translate(170, 30)'),
        g3 = graphics.environmentLayer.append('g').attr('transform', 'translate(15, 210)'),
        g4 = graphics.environmentLayer.append('g').attr('transform', 'translate(170, 210)');
    graphics.environmentLayer.append('text').attr('class', 'benefits-header').text('Environment');
    benefits.environment.path = g1.selectAll('path').data(benefits.environment.pie(benefits.environment.data.start)).enter().append('path').attr('fill', function(d, i) {
        return benefits.environment.color[i];
    }).attr('d', benefits.environment.arc).each(function(d) { this._current = d; });
    benefits.environment.text = g1.append('text').attr('text-anchor', 'middle').attr('y', 4).attr('class', 'benefits-perc');
    g2.append('rect').attr('width', 164).attr('height', 150).attr('fill', '#fff');
    graphics.environmentSquare = g2.append('rect').attr('width', 0).attr('height', 0).attr('x', 0).attr('y', 150).attr('fill', '#31B5AD');
    graphics.environmentLabel = g2.append('text').attr('class', 'bold-12').text('160 000km²').attr('x', 30).attr('y', 100);
    g3.append('text').attr('class', 'bold-12').text('EU area exposed to').attr('y', 0);
    g3.append('text').attr('class', 'bold-12').text('eutrophication').attr('y', 16);
    g4.append('text').attr('class', 'bold-12').text('EU area exposed').attr('y', 0);
    g4.append('text').attr('class', 'bold-12').text('to acidification').attr('y', 16);
    restoreEnvironment(2,1);
}

function launchEnvironment() {
    graphics.environmentLabel.transition().duration(1500).tween('text', function() {
        var q = d3.interpolate( benefits.environment.squareValues[1],  benefits.environment.squareValues[0]);
        return function(t) {
            this.textContent = Math.floor(q(t)) + ' ' + Math.round((q(t) % 1) * 10) + '00 km²';
        };
    });
    animatePie(benefits.environment.data.upper[0]);
    graphics.environmentSquare.transition().duration(1500).attr('width', (sqrt(benefits.environment.squareValues[0] / benefits.environment.squareValues[1]) * 164)).attr('height', (sqrt(benefits.environment.squareValues[0] / benefits.environment.squareValues[1]) * 150)).attr('y', 150 - (sqrt(benefits.environment.squareValues[0] / benefits.environment.squareValues[1]) * 150));
}

function sqrt(a) {
    return Math.sqrt(a);
}

function restoreEnvironment(a, b) {
    graphics.environmentLabel.transition().duration(1500).tween('text', function() {
        var q = d3.interpolate( benefits.environment.squareValues[a],  benefits.environment.squareValues[b]);
        return function(t) {
            this.textContent = Math.floor(q(t)) + ' ' + Math.round(q(t) % 1) + '00 km²';
        };
    });
    animatePie(benefits.environment.data.lower[0]);
    graphics.environmentSquare.transition().duration(1500).attr('width', 164).attr('height', 150).attr('y', 0);
}

function animatePie(percent) {
    var progress = benefits.environment.data.current,
        timeout = setTimeout(function () {
            clearTimeout(timeout);
            benefits.environment.path = benefits.environment.path.data(benefits.environment.pie(calcPercent(percent)));
            benefits.environment.path.transition().duration(2000).attrTween('d', function (a) {
                var i  = d3.interpolate(this._current, a),
                    i2 = d3.interpolate(progress, percent);
                this._current = i(0);
                return function(t) {
                    benefits.environment.text.text( benefits.environment.format(i2(t) / 100) );
                    return benefits.environment.arc(i(t));
                };
            });
        }, 200);
    benefits.environment.data.current = percent;
}

function setToNow() {
    restoreExpectancy();
    benefits.health.running = 'restore';
    restoreHealth(benefits.health.current);
    restoreEconomic();
    restoreEnvironment(0,1);
}

function setTo2030() {
    launchExpectancy();
    benefits.health.running = 'launch';
    launchHealth(benefits.health.current);
    lauchEconomic();
    launchEnvironment();
}

// helper functions

// function positionX(x, el) {
//     console.log('X');
//     if (x < 64) {
//         if (toggleStatus) {
//             d3.select(el).attr('class', 'action-toggle-button');
//             graphics.mainLayer.attr('class', '');
//             toggleStatus = false;
//             setToNow();
//         }
//         return 52;
//     } else {
//         if(!toggleStatus) {
//             d3.select(el).attr('class', 'action-toggle-button action-toggle-button-active');
//             graphics.mainLayer.attr('class', 'benefits-2030');
//             toggleStatus = true;
//             setTo2030();
//         }
//         return 76;
//     }
// }
//
// function limitX(x) {
//     var limitLeft = 52,
//         limitRight = 76;
//     if (x < limitLeft) {
//         x = limitLeft;
//     } else if (x > limitRight) {
//         x = limitRight;
//     }
//     return x;
// }

function calcPercent(percent) {
    return [percent, 100-percent];
}

export const render = (element) => {
    buildCanvas(element);
    buildToggle();
    buildHealth();
    buildExpectancy();
    buildEconomic();
    buildEnvironment();
};
